import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {Badge, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip} from "reactstrap";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import {FormattedMessage} from "react-intl";
import _ from "lodash";
import SelectRows from "../../../../../SelectRows";

class QuestionRows extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      modalRows: props.action.rows || [],
    };

    this.toggleModalRows = this.toggleModalRows.bind(this);
  }

  toggleModalRows(){
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  render() {
    const {action, rows, changeable, questionObject} = this.props;
    const {modalOpen, modalRows} = this.state;

    if (!changeable) {
      return action.rows.map((id, i, arr) => {
        const tooltipId = "rowTooltipId-" + Math.random().toString(36).substring(7);
        let divider = i < arr.length - 1 && '| ';
        const row = rows.find(q => q.id === id);

        return <React.Fragment key={id}>
          <span className="pointer" id={tooltipId}>{row.position + 1}. </span>
          <UncontrolledTooltip target={tooltipId}>
            {questionObject.rowsImage ? <img src={row.content} className="img-100"/> : <span className="img-30" dangerouslySetInnerHTML={{__html: row.stripedContent}}/>}
          </UncontrolledTooltip>
          {divider}
        </React.Fragment>
      })
    }

    const modal = <Modal isOpen={modalOpen} toggle={this.toggleModalRows} size="xl">
      <ModalHeader tag="h2" toggle={this.toggleModalRows}>Wybierz wiersze</ModalHeader>
      <hr className="my-0"/>
      <ModalBody>
        <div className="w-75 d-inline-block">
          <SelectRows questionId={action.question} value={modalRows} onChange={rows => {
            this.setState({
              modalRows: rows,
            })
          }} />
        </div>
        <div className="w-25 d-inline-block pl-3">
          Wybranych wierszy: {modalRows.length}
        </div>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.choose">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda mb-0"
            loading={false}
            data-style={ZOOM_OUT}
            onClick={() => {
              this.props.handleRowsChanged(modalRows);
              this.setState({
                modalOpen: false,
              })
            }}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Badge color={!_.isEmpty(action.rows) ? 'secondary' : 'warning'} className="mx-1 pointer d-inline-flex flex-wrap" onClick={this.toggleModalRows}>{!_.isEmpty(action.rows) ? action.rows.map((id, i, arr) => {
          let divider = i < arr.length - 1 && <span className="mx-1">|</span>;
          const row = rows.find(q => q.id === id);

          if (row.type === 'differential') {
            if (questionObject.rowsImage) {
              return <span key={id} className="img-20">{row.position + 1}. <img src={row.leftContent}/> - <img src={row.rightContent}/>{divider}</span>
            }
            return <React.Fragment key={id}>{row.position+1}. <span className="ch-25 img-20 question-badge ws-nowrap d-inline-block" dangerouslySetInnerHTML={{__html: row.stripedLeftContent}} /> - <span className="ch-25 img-20 question-badge ws-nowrap d-inline-block" dangerouslySetInnerHTML={{__html: row.stripedRightContent}} /> {divider}</React.Fragment>;
          }

          if (questionObject.rowsImage) {
            return <span key={id} className="img-20">{row.position + 1}. <img src={row.content}/>{divider}</span>
          }

          return <React.Fragment key={id}><span className="ch-25 img-20 question-badge ws-nowrap d-inline-block" dangerouslySetInnerHTML={{__html: row.position+1 + '. ' + row.stripedContent}} /> {divider}</React.Fragment>;
        }) : 'Wybierz wiersze...'}</Badge>
        {modal}
      </React.Fragment>
    );
  }
}

QuestionRows.defaultProps = {
  changeable: true
};

QuestionRows.propTypes = {
  action: PropTypes.shape({
    question: PropTypes.number.isRequired,
    rows: PropTypes.array.isRequired,
  }).isRequired,
  handleRowsChanged: PropTypes.func,
  changeable: PropTypes.bool.isRequired
};

function mapStateToProps(state, props) {
  let rows = [];
  if(props.action.question){
    rows = state.survey.structure.data.questions[props.action.question].rows.map(aId => state.survey.structure.data.rows[aId]);
    let position = 0;
    rows = rows.map(row => {
      const ret = {
        ...row,
        position
      };

      position++;
      return ret;
    });
  }


  return {
    rows,
    questionObject: state.survey.structure.data.questions[props.action.question]
  }
}

export default connect(mapStateToProps)(QuestionRows);